export const SELECT_CARD_OVER = 'REPORTING_SELECT_CARD_OVER';

export const selectCardOver = cardIndex => ({
  type: SELECT_CARD_OVER,
  cardIndexOver: cardIndex,
});
